import React from "react";

import LoggedInMenu from "./LoggedInMenu";

export default function NotFound(props: any) {
  return (
    <>
      <LoggedInMenu history={props.history} />

      <div className="content-wrapper">
        <div className="sitecontent">
          <h3 className="sectiontitle">Nicht gefunden</h3>
          <h4>Diese Seite wurde nicht gefunden.</h4>
        </div>
      </div>
    </>
  );
}
